import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function SaveAlertDialog({ open, onClose }) {
  return (
    <Dialog
      open={open}
      // onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        id="alert-dialog-title"
        sx={{
          textAlign: "center",
        }}
      >
        Save Your Plan
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          To keep your current plan, please click <strong>"Save Plans"</strong>.
          <br />
          If you're ready to proceed, you can also click{" "}
          <strong>"Request a Quote"</strong> to get an estimate based on your
          selections.
          <br />
          <br />
          <strong>Important:</strong> If you do not save, your plan will be
          lost.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          variant="contained"
          color="primary"
          sx={{ margin: "0 auto" }}
        >
          Proceed
        </Button>
      </DialogActions>
    </Dialog>
  );
}
